import React from 'react';
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectCurrentUser } from '@shared/store/auth.duck';
import { isCompanyAdminUser, isOfficeAdminUser } from '@shared/utils/AccessControl';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { tablet } from '@shared/ui/atoms/MediaQueries';
import { ReportingContentCardSmall } from '@features/settings/pages/reporting-page/components/ReportingContentCardSmall';
import { OfficeUsageContentWrapper } from "./OfficeUsageStructure";

export function OfficeAutomaticCheckinSection() {
  const user = useSelector(selectCurrentUser);
  const {t} = useTranslation();
  const isCompanyAdmin = isCompanyAdminUser(user);

  // No-shows are open to company and office admins, the check-in log to company admins only
  if (!user?.companyEntity?.automaticOfficeCheckinEnabled || (!isCompanyAdmin && !isOfficeAdminUser(user))) {
    return null;
  }

  return (
    <Section>
      <HeadlineMedium style={{marginBottom: 16}}>{t('reports-page.automatic-checkin-title')}</HeadlineMedium>
      <CardRow>
        {isCompanyAdmin && <CardContainer>
          <ReportingContentCardSmall imageUrl={"/assets/icons/standard/Office.svg"}
                                     title={"reports-page.automatic-checkin-log-title"}
                                     isVisible={true}
                                     description={"reports-page.automatic-checkin-description"}
                                     link={"/manage/reporting/automatic-checkin"} />
        </CardContainer>}
        <CardContainer>
          <ReportingContentCardSmall imageUrl={"/assets/icons/font/Users.svg"}
                                     title={"reports-page.no-shows-title"}
                                     isVisible={true}
                                     description={"reports-page.no-shows-description"}
                                     link={"/manage/reporting/no-shows"} />
        </CardContainer>
      </CardRow>
    </Section>
  )
}

const Section = styled(OfficeUsageContentWrapper)`
  margin-top: 48px;
`

const CardRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  @media (${tablet}) {
    grid-template-columns: repeat(2, minmax(0, 440px));
  }
`

const CardContainer = styled.div`
  border-radius: 16px;
  border: 1px solid var(--Neutrals-Light-Grey, #EDEDED);
`
